import { useDripsyTheme } from 'dripsy'
import type { DripsyTheme } from './index'

export default function useTheme() {
  return (useDripsyTheme().theme as any) as DripsyTheme
}
